import { customAxios, IDUSUARIO,USERNAME, FDV_URL } from '../constants';
import { FETCH_ASIGNACION_DEFINITIVA } from './types';
import moment from "moment";
import { evalAction, serverError } from '../utils/actionError';

export function fetchAsignacionDefinitiva(
        numero,
        numPedidoVeh,
        nurFichaVtaPedido,
        numProfVeh,
        codClie,
        desBaumuster,
        codCia ,
        codProv,
        vendedor,
        codFilial,
        codPropietario,
        indCorreoAduana,
        fechaCompromiso,
        fechaAsignacionDefinitiva = fechaAsignacionDefinitiva !== undefined ? fechaAsignacionDefinitiva:moment(moment().toDate()).format("DD/MM/YYYY")
      ) {

        console.log('fechaAsignacionDefinitiva',fechaAsignacionDefinitiva = fechaAsignacionDefinitiva !== undefined ? fechaAsignacionDefinitiva:moment(moment().toDate()).format("DD/MM/YYYY"));
        console.log('fechaAsignacionDefinitiva',fechaAsignacionDefinitiva = fechaAsignacionDefinitiva !== undefined ? fechaAsignacionDefinitiva:moment(moment().toDate()).format("DD/MM/YYYY"));

      const config = {
        headers: {
          idUsuario: IDUSUARIO,
          codUsuario:USERNAME
        },
        params: {
          numPedidoVeh,
          nurFichaVtaPedido,
          numProfVeh,
          tipoRefProc:'AD',
          codClie,
          desBaumuster,
          indAsigDef:'S',
          codCia ,
          codProv,
          vendedor,
          codFilial,
          codPropietario,
          indCorreoAduana,
          fechaCompromiso,
          fechaAsignacionDefinitiva
        }
  };

  const data = {

  };

  const request = customAxios.put(`${FDV_URL}/ficha-venta/fichas-venta/${numero}/pedidos/${numPedidoVeh}/asignacion-definitiva`, data, config)
                    .then(({ data }) => evalAction(data, 'adjuntar'))
                  .catch(error => serverError(error, 'adjuntar'));

  return {
    type: FETCH_ASIGNACION_DEFINITIVA,
    payload: request,
  };
}



// WEBPACK FOOTER //
// ./src/actions/AsginacionDefinitiva.js